export var Variant = {
  Auto: 'auto',
  Temporary: 'temporary',
  Persistent: 'persistent'
};